import axios, { getData } from 'lib/axios'

export const getCart = async () => {
  const response = await axios.get(`/cart-items`)
  return getData(response)
}
export const postCart = async (data) => {
  const response = await axios.post(`/cart-items`, data)
  return getData(response)
}
export const deleteCart = async (cart_id) => {
  const response = await axios.delete(`/cart-items/${cart_id}`)
  return getData(response)
}

export const getOneCart = async (jobAdId) => {
  const response = await axios.get(`/recruitment/carts/job-postings/${jobAdId}`)
  return getData(response)
}

export const createSelectItem = async (data) => {
  const response = await axios.post(`/recruitment/carts/select-items`, data)
  return getData(response)
}
export const createCheckout = async (data) => {
  const response = await axios.post(`/recruitment/carts/checkout`, data)
  return getData(response)
}
